import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as insight360Actions from '../../../actions/insight360Actions';
import settingsIconActive from '../../../images/salescatalyst/configuration_icon_active.png';
import UserPreference from '../../../containers/UserPreference';
import { PREFERENCE_BRAND_CATALYST } from '../../../constants';

class BrandCatalystConfigurationScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  closePopupFn = () => {
    const { nodeRef } = this.props;
    nodeRef.hide();
  }

  render() {
    return (
      <div className="position-relative sc-config-screen">
        <h3 className="margin-top-10 margin-bottom-15 text-align-center">
          <img className="sc-icon-img margin-right-10" src={settingsIconActive} alt="Session Settings" />
          Session Settings
        </h3>
        <UserPreference
          screenType={'session'}
          sessionClose={this.closePopupFn}
          defaultSection={undefined}
          sessionType={PREFERENCE_BRAND_CATALYST}
        />
      </div>
    );
  }
}

// function mapStateToProps(state) {
//   return {
//     subEntities: state.salesCatalyst.dataSelection.subEntities,
//   };
// }

function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

BrandCatalystConfigurationScreen.propTypes = {
  nodeRef: PropTypes.shape({}),
};


export default connect(
  mapDispatchToProps,
)(BrandCatalystConfigurationScreen);
